// Convert a WhatsApp input value (URL, phone number with or without country code,
// with spaces/dashes/parentheses) into a clickable wa.me / chat URL.
// - If input is already an http(s) URL, return as-is.
// - If input is a bare number (digits + optional leading '+'), return https://wa.me/<digits>.
// - Empty/invalid → returns empty string (caller hides the icon).
export function normalizeWhatsAppUrl(value) {
    if (!value) return "";
    const v = String(value).trim();
    if (!v) return "";
    if (/^https?:\/\//i.test(v)) return v; // already a URL (channel or chat link)
    // strip non-digits (keeps international format)
    const digits = v.replace(/\D+/g, "");
    if (!digits) return "";
    return `https://wa.me/${digits}`;
}
